import React, { lazy, Suspense } from 'react';

const LazyAdminLeads = lazy(() => import('./AdminLeads'));

const AdminLeads = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAdminLeads {...props} />
  </Suspense>
);

export default AdminLeads;
